import React from 'react';
import { Stepper } from './Stepper';

interface IPageInfo {
  headline: string;
  subheading?: (string | React.ReactNode)[];
  steps?: number;
  currentStep?: number;
}

export const PageInfo = (props: IPageInfo) => {
  let renderedSubheading = null;

  if (props.subheading && props.subheading.length > 0) {
    renderedSubheading = props.subheading.map((line, index) => {
      if (typeof line === 'string') {
        const parts = line.split(/\*\*(.*?)\*\*/);
        return (
          <p key={index} className="tw:text-sm tw:sm:text-lg tw:font-extralight">
            {parts.map((part, i) => (i % 2 === 1 ? <strong key={i}>{part}</strong> : part))}
          </p>
        );
      }

      return (
        <p key={index} className="tw:text-sm tw:sm:text-lg tw:font-extralight">
          {line}
        </p>
      );
    });
  }

  return (
    <>
      <h3 className="tw:text-3xl tw:leading-tight tw:lg:mb-4 tw:font-medium">{props.headline}</h3>
      {props.steps && props.currentStep && <Stepper steps={props.steps} currentStep={props.currentStep} />}
      {renderedSubheading}
    </>
  );
};
